import React from 'react';
import styles from './PageContainer.module.css';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

interface PageBodyProps {
  children: React.ReactNode;
  className?: string;
}

export const PageBody: React.FC<PageBodyProps> = ({ children, className }) => (
  <div className={`${styles['page-body']}${className ? ` ${className}` : ''}`}>
    {children}
  </div>
);

const PageContainer: React.FC<PageContainerProps> = ({ children, className }) => (
  <div className={`${styles['page-container']}${className ? ` ${className}` : ''}`}>
    {children}
  </div>
);

export default PageContainer;
